import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import ENV from '../config/env';

// Animation preset
const fadeIn = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 0.8 }
};

// Helper: Check if string is a color hex
const isColorHex = (str) => {
    return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(str);
};

// Component: Product card for partner products grid
const PartnerProductCard = ({ product, onClick }) => {
    // Get the first image to display
    const getDisplayImage = () => {
        if (product.productImages && product.productImages.length > 0) {
            return product.productImages[0];
        }
        if (product.allImages && product.allImages.length > 0) {
            return product.allImages[0];
        }
        return `${ENV.FILE_SERVER_URL}/images/default-product.jpg`;
    };

    const imageUrl = getDisplayImage();
    const { name, price, shortDesc, category, brand, availableColors } = product;

    return (
        <motion.div
            {...fadeIn}
            className="border rounded-lg overflow-hidden transition-all cursor-pointer hover:border-2 hover:border-primary hover:shadow-lg hover:shadow-primary/20 bg-white"
            onClick={() => onClick(product)}
        >
            <div className="h-48 relative bg-gray-100">
                <img
                    src={imageUrl}
                    alt={name}
                    className="w-full h-full object-contain p-4"
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = `${ENV.FILE_SERVER_URL}/images/default-product.jpg`;
                    }}
                />
            </div>
            <div className="p-4">
                <div className="flex justify-between items-start mb-2">
                    <h3 className="text-base font-semibold text-gray-900 break-words line-clamp-2">
                        {name}
                    </h3>
                    {/* <span className="text-primary font-medium text-sm whitespace-nowrap ml-2 flex-shrink-0">
                        {price}
                    </span> */}
                </div>
                <p className="text-gray-600 text-xs mb-3 break-words line-clamp-2">
                    {shortDesc}
                </p>
                <div className="flex justify-between items-center">
                    <span className="bg-primary/10 text-primary text-xs px-3 py-2 rounded-full line-clamp-1 max-w-[60%]">
                        {category}
                    </span>
                    <div className="flex items-center text-primary text-xs font-bold flex-shrink-0">
                        <span>Ver detalles</span>
                        <ChevronRight size={12} className="ml-1" />
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default PartnerProductCard;